import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface CheckUserInterface {
  mobile: string;
}

export const useCheckUser = () => {
  const mutate = useMutation(({ mobile }: CheckUserInterface) => {
    return postAPI('/creator-api/check_user', {
      mobile,
    });
  });

  return mutate;
};

export default useCheckUser;
